import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "icon"]

  toggle() {
    const shouldShowPassword = this.inputTarget.type === "password"

    this.inputTarget.type = shouldShowPassword ? "text" : "password"
    this.buttonTarget.setAttribute("aria-label", shouldShowPassword ? "Ocultar senha" : "Mostrar senha")
    this.buttonTarget.setAttribute("aria-pressed", shouldShowPassword ? "true" : "false")
    this.iconTarget.classList.toggle("bi-eye", !shouldShowPassword)
    this.iconTarget.classList.toggle("bi-eye-slash", shouldShowPassword)
  }
}
